import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const a = o(
  (e, i) => /* @__PURE__ */ l.jsx(
    r,
    {
      ref: i,
      ...e,
      image: (s) => /* @__PURE__ */ l.jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...s,
          children: [
            /* @__PURE__ */ l.jsxs("g", { clipPath: "url(#clip0_3327_70894)", children: [
              /* @__PURE__ */ l.jsx("path", { d: "M0 0h16v16H0z" }),
              /* @__PURE__ */ l.jsx(
                "path",
                {
                  fill: "currentColor",
                  fillRule: "evenodd",
                  d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 5a1 1 0 0 0-.707.293L6.586 6 5.172 4.586l.707-.707A3 3 0 1 1 8 9H7V7h1a1 1 0 0 0 0-2m0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
                  clipRule: "evenodd"
                }
              )
            ] }),
            /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3327_70894", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
          ]
        }
      )
    }
  )
);
a.displayName = "HelpIcon";
export {
  a as HelpIcon,
  a as default
};
//# sourceMappingURL=index.js.map
